module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/217.5cc3d20a.png";